function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.626,18.609c-2.55,0-4.626-2.075-4.626-4.626s2.075-4.626,4.626-4.626,4.626,2.075,4.626,4.626-2.075,4.626-4.626,4.626Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.626,44.626c-2.55,0-4.626-2.075-4.626-4.626s2.075-4.626,4.626-4.626,4.626,2.075,4.626,4.626-2.075,4.626-4.626,4.626Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M9.626,70.642c-2.55,0-4.626-2.075-4.626-4.626s2.075-4.626,4.626-4.626,4.626,2.075,4.626,4.626-2.075,4.626-4.626,4.626Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.742,16.646c-1.468,0-2.662-1.195-2.662-2.663s1.195-2.662,2.662-2.662h45.595c1.468,0,2.662,1.194,2.662,2.662s-1.195,2.663-2.662,2.663H26.742Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.742,42.662c-1.468,0-2.662-1.194-2.662-2.662s1.195-2.663,2.662-2.663h45.595c1.468,0,2.662,1.195,2.662,2.663s-1.195,2.662-2.662,2.662H26.742Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.742,68.679c-1.468,0-2.662-1.195-2.662-2.663s1.195-2.663,2.662-2.663h45.595c1.468,0,2.662,1.195,2.662,2.663s-1.195,2.663-2.662,2.663H26.742Z"
});

var SvgNavMenu01 = function SvgNavMenu01(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavMenu01, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav_menu01.7f20db79.svg";
export { ForwardRef as ReactComponent };